import Vue from 'vue';

import Wishlist from './Wishlist';
import WishlistModal from './WishlistModal';
import WishlistModalOverview from './WishlistModalOverview';

Vue.component('brku-wishlist', Wishlist);
Vue.component('brku-wishlist-modal', WishlistModal);
Vue.component('brku-wishlist-modal-overview', WishlistModalOverview);